import { ActionTypeReducer, GenStateType, NestedKeys } from "helpers/types";
import { Project } from "models/project_type";
import { TaskCard } from "models/tasks_type";
import { TimerGetType, TimerType } from "models/timer_type";
import { UserModelGet } from "models/user_model";

type StateType = {
    loading: boolean;
    loggedUser: UserModelGet;
    projects: Project[];
    projectSelected: Project;
    tasksList: TaskCard[];
    taskSelected: TaskCard;
    inputType: 'auto' | 'manual';
    timer: TimerType;
    timerList: TimerGetType[];
    timerFormFieldsError: Partial<Record<NestedKeys<TimerType>, string>>;
}

type ActionType = GenStateType<StateType>;

const initialState: StateType = {
    loading: false,
    loggedUser: null,
    projects: [],
    projectSelected: null,
    tasksList: [],
    taskSelected: null,
    inputType: 'auto',
    timer: null,
    timerList: [],
    timerFormFieldsError: {
        initialMoment: '',
        finalMoment: '',
    }
}

const reducer = (state: StateType, action: ActionTypeReducer<ActionType>) => {
    switch (action.type) {
        case 'setLoading':
            return { ...state, loading: action.payload };
        case 'setLoggedUser':
            return { ...state, loggedUser: action.payload };
        case 'setProjects':
            return { ...state, projects: action.payload };
        case 'setProjectSelected':
            return { ...state, projectSelected: action.payload };
        case 'setTasksList':
            return { ...state, tasksList: action.payload };
        case 'setTaskSelected':
            return { ...state, taskSelected: action.payload };
        case 'setTimer':
            return { ...state, timer: action.payload };
        case 'setTimerList':
            return { ...state, timerList: action.payload };
        case 'setInputType':
            return { ...state, inputType: action.payload };
        case 'setTimerFormFieldsError':
            return { ...state, timerFormFieldsError: action.payload };
        default:
            return state;
    }
}

export { initialState, reducer };